export const initState = {
	file: '',
	_file: 'init',
};

export default initState;
